export default __webpack_public_path__ + "static/team-meeting-b4a42805c3b5a6f7c7ddcfbb1060a923.jpg";